module.exports = __webpack_public_path__ + "img/blue-screen-2.fa0bffa5.webp";